/**
 * Quick task 260611-gre — Board/List segmented control for the KanbanBoardPage header.
 *
 * Pure UI; no auth, no data fetching. Audience is NOT referenced here —
 * the parent renders this switcher for both internal and external surfaces
 * (Phase 23 isolation preserved).
 */

export interface BoardListSwitcherProps {
  value: 'board' | 'list';
  onChange: (next: 'board' | 'list') => void;
}

export function BoardListSwitcher({ value, onChange }: BoardListSwitcherProps) {
  return (
    <div
      role="group"
      aria-label="View mode"
      data-testid="board-list-switcher"
      className="inline-flex items-center gap-0.5 rounded-md border border-ms-border bg-ms-canvas p-0.5"
    >
      <button
        type="button"
        aria-pressed={value === 'board'}
        data-testid="view-mode-board"
        onClick={() => onChange('board')}
        className={`px-2.5 py-1 text-xs font-medium rounded ${
          value === 'board'
            ? 'bg-ms-surface text-ms-text-strong ring-1 ring-ms-border'
            : 'text-ms-text-secondary hover:text-ms-text'
        }`}
      >
        Board
      </button>
      <button
        type="button"
        aria-pressed={value === 'list'}
        data-testid="view-mode-list"
        onClick={() => onChange('list')}
        className={`px-2.5 py-1 text-xs font-medium rounded ${
          value === 'list'
            ? 'bg-ms-surface text-ms-text-strong ring-1 ring-ms-border'
            : 'text-ms-text-secondary hover:text-ms-text'
        }`}
      >
        List
      </button>
    </div>
  );
}
